import React from "react";
import createReport from "../../../util/operations/reports";
import { createSolarReport } from "../../../util/operations/solar";
import {
  pingSlackOnReportCreation,
  pingSlackonReportCreationError,
} from "../../../util/operations/zapier";
import CollectInformation from "../../multi-step-components/CollectInformation";
import GenerateReportLoading from "../../multi-step-components/GenerateReportLoading";
import SelectInsuranceOption from "../../multi-step-components/SelectInsuranceOption";
import SelectRoofSteepness from "../../multi-step-components/SelectRoofSteepness";
import SelectRoofType from "../../multi-step-components/SelectRoofType";
import EnterRoofAdress from "../../multi-step-components/EnterRoofAdress";
import addReferral from "../../../util/operations/referral";
import PageLoader from "../../PageLoader";
import AverageElectricityForm from "../../multi-step-components/AverageElectricityForm";

export const renderRequiredStep = (
  step,
  setStep,
  roofData,
  setRoofData,
  handleGenerateReport,
  userAddress,
  errorMessage,
  setErrorMessage,
  refCode,
  roofType
) => {
  switch (step) {
    case 0:
      return (
        <EnterRoofAdress
          setStep={setStep}
          roofData={roofData}
          setRoofData={setRoofData}
          userAddress={userAddress}
          refCode={refCode}
        />
      );
    case 1:
      return (
        <SelectRoofType
          setStep={setStep}
          roofData={roofData}
          setRoofData={setRoofData}
        />
      );
    case 2:
      return (
        <SelectRoofSteepness
          setStep={setStep}
          roofData={roofData}
          setRoofData={setRoofData}
        />
      );
    case 3:
      return (
        <SelectInsuranceOption
          setStep={setStep}
          roofData={roofData}
          setRoofData={setRoofData}
        />
      );
    case 4:
      return (
        <CollectInformation
          setStep={setStep}
          roofData={roofData}
          setRoofData={setRoofData}
        />
      );
    case 5:
      return (
        <GenerateReportLoading
          setStep={setStep}
          roofData={roofData}
          handleGenerateReport={handleGenerateReport}
          userAddress={userAddress}
          errorMessage={errorMessage}
          setErrorMessage={setErrorMessage}
          refCode={refCode}
          roofType={roofType}
        />
      );

    default:
      return <PageLoader />;
  }
};

export const handleGenerateReport = async (
  roofData,
  userAddress,
  setStep,
  history,
  setErrorMessage,
  refCode,
  typeOfRoof,
  roofSquareSize
) => {
  const {
    email,
    fullName,
    insurance,
    phoneNumber,
    roofSteepness,
    monthlyBill,
    roofType,
  } = roofData;

  if (typeOfRoof === "solar") {
    const response = await createSolarReport({
      fullname: fullName,
      email,
      phoneNumber,
      fullAddress: userAddress,
      monthlyBill,
      roofSquareSize,
    });

    if (response && response.status) {
      const {
        data: { id },
      } = response;
      //  await ping solar report creation
      return history.push(`/solar/report/${id}`);
    }

    return setErrorMessage("ASK_ROOF_SQUARE_SIZE");
    // return setStep(6);
  }

  const newRoofData = {
    fullAddress: userAddress,
    name: fullName,
    email,
    phone: phoneNumber,
    roofType,
    roofSteepness,
    insuranceAvailable: insurance.toLowerCase(),
  };

  const response = await createReport(newRoofData);

  if (response && response.status) {
    if (refCode) {
      await addReferral({ ref_code: refCode, identifier: email });
    }

    await pingSlackOnReportCreation(response.data);

    const {
      data: { id },
    } = response;

    return history.push(`/report/${id}`);
  }

  await pingSlackonReportCreationError(newRoofData);

  response && setErrorMessage(response.message);
};
